/* ============================================================
   POKEMON CARD SHOP — CUSTOM JAVASCRIPT
   ============================================================ */

'use strict';

// ===== HEADER: 検索トグル =====
const searchToggle = document.getElementById('search-toggle');
const searchBar = document.getElementById('search-bar');

if (searchToggle && searchBar) {
  searchToggle.addEventListener('click', () => {
    const isHidden = searchBar.hidden;
    searchBar.hidden = !isHidden;
    if (!isHidden) {
      searchBar.querySelector('input')?.focus();
    }
  });
}

// ===== HEADER: モバイルメニュー =====
const mobileMenuToggle = document.getElementById('mobile-menu-toggle');
const mobileMenu = document.getElementById('mobile-menu');

if (mobileMenuToggle && mobileMenu) {
  mobileMenuToggle.addEventListener('click', () => {
    const isOpen = mobileMenu.classList.contains('is-open');
    mobileMenu.classList.toggle('is-open', !isOpen);
    mobileMenuToggle.setAttribute('aria-expanded', String(!isOpen));
    mobileMenu.setAttribute('aria-hidden', String(isOpen));
    document.body.style.overflow = isOpen ? '' : 'hidden';
  });
  // オーバーレイクリックで閉じる
  document.addEventListener('click', (e) => {
    if (mobileMenu.classList.contains('is-open') &&
        !mobileMenu.contains(e.target) &&
        !mobileMenuToggle.contains(e.target)) {
      mobileMenu.classList.remove('is-open');
      mobileMenuToggle.setAttribute('aria-expanded', 'false');
      mobileMenu.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
  });
}

// ===== PRODUCT GALLERY: サムネイル切替 =====
const galleryThumbs = document.querySelectorAll('.gallery__thumb');
const galleryMainImg = document.getElementById('gallery-main-img');

if (galleryThumbs.length && galleryMainImg) {
  galleryThumbs.forEach((thumb) => {
    thumb.addEventListener('click', () => {
      // アクティブ状態更新
      galleryThumbs.forEach(t => {
        t.classList.remove('active');
        t.setAttribute('aria-selected', 'false');
      });
      thumb.classList.add('active');
      thumb.setAttribute('aria-selected', 'true');

      // メイン画像更新
      const src = thumb.dataset.src;
      const zoom = thumb.dataset.zoom;
      const alt = thumb.dataset.alt;
      galleryMainImg.src = src;
      galleryMainImg.alt = alt;
      galleryMainImg.dataset.zoom = zoom;
    });
  });
}

// ===== PRODUCT GALLERY: ズーム機能 =====
const zoomWrap = document.getElementById('zoom-wrap');

if (zoomWrap && galleryMainImg) {
  let isZoomed = false;

  zoomWrap.addEventListener('mousemove', (e) => {
    if (window.innerWidth < 1024) return; // モバイルでは無効

    const rect = zoomWrap.getBoundingClientRect();
    const x = ((e.clientX - rect.left) / rect.width) * 100;
    const y = ((e.clientY - rect.top) / rect.height) * 100;

    galleryMainImg.style.transformOrigin = `${x}% ${y}%`;
    galleryMainImg.style.transform = 'scale(2)';
  });

  zoomWrap.addEventListener('mouseleave', () => {
    galleryMainImg.style.transform = '';
    galleryMainImg.style.transformOrigin = '';
  });
}

// ===== PRODUCT GALLERY: フルスクリーン =====
const fullscreenBtn = document.getElementById('fullscreen-btn');
const fullscreenModal = document.getElementById('gallery-fullscreen');
const fullscreenClose = document.getElementById('fullscreen-close');
const fullscreenImg = document.getElementById('fullscreen-img');
const fullscreenPrev = document.getElementById('fullscreen-prev');
const fullscreenNext = document.getElementById('fullscreen-next');

let currentImageIndex = 0;
const allImages = [...galleryThumbs].map(t => ({
  src: t.dataset.zoom || t.dataset.src,
  alt: t.dataset.alt
}));

function openFullscreen(index) {
  if (!fullscreenModal || !allImages.length) return;
  currentImageIndex = index;
  fullscreenImg.src = allImages[index].src;
  fullscreenImg.alt = allImages[index].alt;
  fullscreenModal.hidden = false;
  document.body.style.overflow = 'hidden';
  fullscreenClose.focus();
}

function closeFullscreen() {
  if (!fullscreenModal) return;
  fullscreenModal.hidden = true;
  document.body.style.overflow = '';
  fullscreenBtn?.focus();
}

if (fullscreenBtn) {
  fullscreenBtn.addEventListener('click', () => {
    const activeThumb = document.querySelector('.gallery__thumb.active');
    const index = [...galleryThumbs].indexOf(activeThumb);
    openFullscreen(Math.max(0, index));
  });
}

if (fullscreenClose) fullscreenClose.addEventListener('click', closeFullscreen);

if (fullscreenPrev) {
  fullscreenPrev.addEventListener('click', () => {
    currentImageIndex = (currentImageIndex - 1 + allImages.length) % allImages.length;
    fullscreenImg.src = allImages[currentImageIndex].src;
    fullscreenImg.alt = allImages[currentImageIndex].alt;
  });
}

if (fullscreenNext) {
  fullscreenNext.addEventListener('click', () => {
    currentImageIndex = (currentImageIndex + 1) % allImages.length;
    fullscreenImg.src = allImages[currentImageIndex].src;
    fullscreenImg.alt = allImages[currentImageIndex].alt;
  });
}

// ESCキーで閉じる
document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape' && fullscreenModal && !fullscreenModal.hidden) {
    closeFullscreen();
  }
  if (!fullscreenModal || fullscreenModal.hidden) return;
  if (e.key === 'ArrowLeft') fullscreenPrev?.click();
  if (e.key === 'ArrowRight') fullscreenNext?.click();
});

// ===== PRODUCT PAGE: バリアント選択 =====
const variantBtns = document.querySelectorAll('.variant-btn');
const variantIdInput = document.getElementById('variant-id');

if (variantBtns.length) {
  variantBtns.forEach((btn) => {
    btn.addEventListener('click', () => {
      const optionName = btn.dataset.optionName;
      const optionValue = btn.dataset.optionValue;

      // 同じオプショングループ内のボタンを非アクティブに
      document.querySelectorAll(`[data-option-name="${optionName}"]`).forEach(b => {
        b.classList.remove('active');
      });
      btn.classList.add('active');

      // 選択値表示を更新
      const selectedDisplay = document.getElementById(`selected-${optionName}`);
      if (selectedDisplay) selectedDisplay.textContent = optionValue;
    });
  });
}

// ===== PRODUCT PAGE: タブ切替 =====
const tabBtns = document.querySelectorAll('.product-tabs__tab');
const tabPanels = document.querySelectorAll('.product-tabs__panel');

tabBtns.forEach((tab) => {
  tab.addEventListener('click', () => {
    const targetPanel = tab.dataset.tab;

    tabBtns.forEach(t => {
      t.classList.remove('active');
      t.setAttribute('aria-selected', 'false');
    });
    tabPanels.forEach(p => {
      p.classList.remove('active');
      p.hidden = true;
    });

    tab.classList.add('active');
    tab.setAttribute('aria-selected', 'true');

    const panel = document.querySelector(`[data-panel="${targetPanel}"]`);
    if (panel) {
      panel.classList.add('active');
      panel.hidden = false;
    }
  });
});

// ===== CART: カート追加（Shopify標準フォーム送信） =====
// JSによる介入なし。Shopify標準の /cart/add POST をそのまま使用。
// ボタン押下時に「追加中...」表示のみ行う。
const productForm = document.getElementById('product-form');

if (productForm) {
  productForm.addEventListener('submit', function() {
    const addBtn = document.getElementById('add-to-cart');
    if (addBtn) {
      addBtn.disabled = true;
      addBtn.textContent = '追加中...';
    }
    // e.preventDefault() は呼ばない → Shopify標準のフォーム送信が走る
  });
}

// カート数を更新
async function updateCartCount() {
  try {
    const res = await fetch('/cart.json');
    const cart = await res.json();
    const countEl = document.querySelector('.header__cart-count');
    if (countEl) {
      countEl.textContent = cart.item_count;
      countEl.hidden = cart.item_count === 0;
    }
  } catch {
    // サイレントフェイル
  }
}

// ===== TOAST 通知 =====
function showToast(message, type = 'info') {
  const container = document.getElementById('toast-container');
  if (!container) return;

  const toast = document.createElement('div');
  toast.className = `toast toast--${type}`;

  const icon = type === 'success'
    ? '<svg width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="var(--color-green)"><polyline points="20 6 9 17 4 12"/></svg>'
    : '<svg width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="var(--color-red)"><circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/></svg>';

  toast.innerHTML = `${icon}<span>${message}</span>`;
  container.appendChild(toast);

  setTimeout(() => {
    toast.style.animation = 'slideIn 0.3s ease reverse';
    setTimeout(() => toast.remove(), 300);
  }, 3000);
}

// ===== FAQ: アコーディオン =====
const faqQuestions = document.querySelectorAll('.faq-item__question');

faqQuestions.forEach((question) => {
  question.addEventListener('click', () => {
    const isExpanded = question.getAttribute('aria-expanded') === 'true';
    const answer = question.nextElementSibling;

    // 他の開いているアイテムを閉じる
    faqQuestions.forEach(q => {
      if (q !== question) {
        q.setAttribute('aria-expanded', 'false');
        const a = q.nextElementSibling;
        if (a) a.hidden = true;
      }
    });

    question.setAttribute('aria-expanded', String(!isExpanded));
    if (answer) answer.hidden = isExpanded;
  });
});

// ===== FAQ: スクロールスパイ =====
const faqSections = document.querySelectorAll('.faq-section');
const faqNavLinks = document.querySelectorAll('.faq-nav__link');

if (faqSections.length && faqNavLinks.length) {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const id = entry.target.id;
        faqNavLinks.forEach(link => {
          link.classList.toggle('active', link.getAttribute('href') === `#${id}`);
        });
      }
    });
  }, { rootMargin: '-100px 0px -60% 0px' });

  faqSections.forEach(section => observer.observe(section));
}

// ===== REVIEWS: カルーセル =====
const reviewsTrack = document.getElementById('reviews-track');
const reviewsPrev = document.getElementById('reviews-prev');
const reviewsNext = document.getElementById('reviews-next');
const reviewsDotsContainer = document.getElementById('reviews-dots');

if (reviewsTrack) {
  const cards = reviewsTrack.querySelectorAll('.review-card');
  let currentIndex = 0;
  const visibleCount = () => window.innerWidth >= 1024 ? 3 : window.innerWidth >= 640 ? 2 : 1;

  // ドット生成
  function buildDots() {
    if (!reviewsDotsContainer) return;
    reviewsDotsContainer.innerHTML = '';
    const total = Math.ceil(cards.length / visibleCount());
    for (let i = 0; i < total; i++) {
      const dot = document.createElement('button');
      dot.className = `reviews-dot${i === currentIndex ? ' active' : ''}`;
      dot.setAttribute('aria-label', `レビュー ${i + 1}`);
      dot.addEventListener('click', () => goTo(i));
      reviewsDotsContainer.appendChild(dot);
    }
  }

  function goTo(index) {
    const total = Math.ceil(cards.length / visibleCount());
    currentIndex = Math.max(0, Math.min(index, total - 1));
    const cardWidth = cards[0].offsetWidth + 24; // gap=24
    reviewsTrack.style.transform = `translateX(-${currentIndex * cardWidth * visibleCount()}px)`;

    // ドット更新
    document.querySelectorAll('.reviews-dot').forEach((dot, i) => {
      dot.classList.toggle('active', i === currentIndex);
    });
  }

  if (reviewsPrev) reviewsPrev.addEventListener('click', () => goTo(currentIndex - 1));
  if (reviewsNext) reviewsNext.addEventListener('click', () => goTo(currentIndex + 1));

  buildDots();
  window.addEventListener('resize', () => { buildDots(); goTo(0); });

  // タッチスワイプ
  let touchStartX = 0;
  reviewsTrack.addEventListener('touchstart', e => { touchStartX = e.touches[0].clientX; }, { passive: true });
  reviewsTrack.addEventListener('touchend', e => {
    const diff = touchStartX - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 50) {
      diff > 0 ? goTo(currentIndex + 1) : goTo(currentIndex - 1);
    }
  });
}

// ===== PRODUCT FILTER =====
const filterBtns = document.querySelectorAll('.product-filter__btn');
const productCards = document.querySelectorAll('.product-card');

filterBtns.forEach((btn) => {
  btn.addEventListener('click', () => {
    filterBtns.forEach(b => {
      b.classList.remove('active');
      b.setAttribute('aria-selected', 'false');
    });
    btn.classList.add('active');
    btn.setAttribute('aria-selected', 'true');

    const filter = btn.dataset.filter;

    productCards.forEach(card => {
      if (filter === 'all') {
        card.style.display = '';
        return;
      }
      // タグによるフィルタリング（data-tags属性を商品カードに追加する想定）
      const tags = card.dataset.tags || '';
      card.style.display = tags.includes(filter) ? '' : 'none';
    });
  });
});

// ===== スクロールアニメーション =====
const animateEls = document.querySelectorAll(
  '.trust-card, .product-card, .review-card, .faq-item'
);

if ('IntersectionObserver' in window && animateEls.length) {
  const animObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.style.opacity = '1';
        entry.target.style.transform = 'translateY(0)';
        animObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });

  animateEls.forEach((el, i) => {
    el.style.opacity = '0';
    el.style.transform = 'translateY(20px)';
    el.style.transition = `opacity 0.4s ease ${i * 0.05}s, transform 0.4s ease ${i * 0.05}s`;
    animObserver.observe(el);
  });
}

// ===== ヘッダースクロール変化 =====
const siteHeader = document.querySelector('.site-header');
if (siteHeader) {
  window.addEventListener('scroll', () => {
    siteHeader.classList.toggle('scrolled', window.scrollY > 40);
  }, { passive: true });
}

// ===== ウィッシュリスト（ローカルストレージ） =====
const wishlistBtn = document.getElementById('wishlist-btn');

if (wishlistBtn) {
  const productId = document.querySelector('[data-product-id]')?.dataset.productId;
  const wishlist = JSON.parse(localStorage.getItem('wishlist') || '[]');

  function updateWishlistBtn() {
    const isWishlisted = wishlist.includes(productId);
    wishlistBtn.querySelector('svg').style.fill = isWishlisted ? 'var(--color-accent)' : 'none';
    wishlistBtn.style.borderColor = isWishlisted ? 'var(--color-accent)' : '';
    wishlistBtn.setAttribute('aria-label', isWishlisted ? 'お気に入りから削除' : 'お気に入りに追加');
  }

  updateWishlistBtn();

  wishlistBtn.addEventListener('click', () => {
    const idx = wishlist.indexOf(productId);
    if (idx === -1) {
      wishlist.push(productId);
      showToast('お気に入りに追加しました', 'success');
    } else {
      wishlist.splice(idx, 1);
      showToast('お気に入りから削除しました', 'info');
    }
    localStorage.setItem('wishlist', JSON.stringify(wishlist));
    updateWishlistBtn();
  });
}

// ===== 在庫カウントダウン演出（社会的証明） =====
// 残り在庫が少ない場合、視聴者数を表示してウォームアップ
const urgencyEl = document.getElementById('urgency-message');
if (urgencyEl) {
  // ランダムな「閲覧中」人数を表示（3〜12人）
  const viewers = Math.floor(Math.random() * 9) + 3;
  const viewerBadge = document.createElement('span');
  viewerBadge.style.cssText = `
    display: inline-flex; align-items: center; gap: 4px;
    font-size: 0.75rem; color: var(--color-text-muted);
    margin-top: 4px;
  `;
  viewerBadge.innerHTML = `
    <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor">
      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
      <circle cx="12" cy="12" r="3"/>
    </svg>
    現在 <strong style="color: var(--color-accent)">${viewers}人</strong> がこの商品を見ています
  `;
  urgencyEl.parentNode?.insertBefore(viewerBadge, urgencyEl.nextSibling);
}
